import { EditableEntity, ICreatableEntityCollection } from '@zdrbm/zdr-native-tools';
import { IConversation } from './Conversation';

export interface IPlacerAssistant {
  conversations: ICreatableEntityCollection<IConversation>;
  addConversation(conversation: IConversation): void;
  getConversation(conversationId: string): IConversation | undefined;
}

export class PlacerAssistant extends EditableEntity<keyof IPlacerAssistant> implements IPlacerAssistant {
  conversations: ICreatableEntityCollection<IConversation>;

  constructor() {
    super(undefined);

    this.conversations = this.createEntityCollection<IConversation>('conversations', []);
  }

  getConversation(conversationId: string): IConversation | undefined {
    const conversation = this.conversations.getItem(conversationId);
    return conversation;
  }

  addConversation(conversation: IConversation): void {
    this.conversations.addItems(undefined, conversation);
  }
  getEntityName(): string {
    return 'PlacerAssistant';
  }

}
